/** Agent data quality: share of one handling agent's active bookings missing enrichment. */
import type { AgentDataQualityPayload, AgentQualityCheckEntry } from "@/types/feed";

import { agentBookingsHref } from "../../feedLinks";
import { formatNum } from "../formatInsight";
import { explainerFor } from "../insightCopy";
import {
  ChangeRow,
  CtaLink,
  EntitySection,
  InsightShell,
  MetricGrid,
  type MetricItem,
} from "../primitives";

function pct(value: number): string {
  return `${Math.round(value)}%`;
}

export function AgentDataQualityView({
  payload,
}: {
  payload: AgentDataQualityPayload;
}) {
  const m = payload.metrics;
  const metricItems: MetricItem[] = m
    ? [
        { label: "Active bookings", value: formatNum(m.active_count) },
        { label: "Worst missing", value: pct(m.worst_missing_pct) },
      ]
    : [];

  const checks: AgentQualityCheckEntry[] = [...(payload.by_check ?? [])].sort(
    (a, b) => b.missing_pct - a.missing_pct,
  );

  return (
    <InsightShell explainer={explainerFor(payload as unknown as Record<string, unknown>)}>
      {metricItems.length > 0 && <MetricGrid items={metricItems} />}
      {checks.length > 0 && (
        <EntitySection title="Missing enrichment">
          {checks.map((c) => (
            <ChangeRow
              key={c.check}
              name={c.label}
              primary={pct(c.missing_pct)}
              subtitle={`${c.missing_count} bookings`}
            />
          ))}
        </EntitySection>
      )}
      {payload.agent && (
        <CtaLink to={agentBookingsHref(payload.agent)}>View agent bookings</CtaLink>
      )}
    </InsightShell>
  );
}
